<template>
    <div class="p-3">
        <h4 class="text-dark">Control Center: My Alerts</h4>
        <div class="row">
            <div class="col-8 p-2">
                <!--ALL STAFF HR ALERTS-->
                <div class="p-3 border-light bg-white my-2">
                    <h4 class="text-capitalize">All staff human resources alerts</h4>

                    <div class="d-flex w-100 justify-content-between mt-3">
                        <span class="mr-2">Timesheet verification</span>
                        <div class="mr-auto">
                            <toggle-button
                                :value="false"
                                color="#D64571"
                                :sync="true"
                                :labels="true"
                            />
                        </div>
                    </div>

                    <div class="d-flex w-100 justify-content-between">
                        <span class="text-nowrap">1st Pay Period Due</span>
                        <select
                            id="paydue1"
                            class="form-control form-control-sm ml-2"
                            style="max-width:6rem;"
                        >
                            <option>15th</option>
                        </select>
                        <span class="text-nowrap ml-auto">1st Pay Period Due</span>
                        <select
                            id="paydue2"
                            class="form-control form-control-sm ml-2"
                            style="max-width:6rem;"
                        >
                            <option>30th</option>
                        </select>
                    </div>

                    <div class="form-row mt-2">
                        <div class="form-group col-3">
                            <label for="al1" class="text-dark font-weight-bold"
                                ><small>Start Warning</small></label
                            >
                            <select id="al1" class="form-control form-control-sm">
                                <option>Immediately</option>
                            </select>
                        </div>
                        <div class="form-group col-3">
                            <label for="al2" class="text-dark font-weight-bold"
                                ><small>Frequency</small></label
                            >
                            <select id="al2" class="form-control form-control-sm">
                                <option>Every Log In</option>
                            </select>
                        </div>
                        <div class="form-group col-3">
                            <label for="al3" class="text-dark font-weight-bold"
                                ><small>Allow Skip Warning</small></label
                            >
                            <select id="al3" class="form-control form-control-sm">
                                <option>3 times</option>
                            </select>
                        </div>
                        <div class="form-group col-3">
                            <label for="al4" class="text-dark font-weight-bold"
                                ><small>Block Until Complete</small></label
                            >
                            <select id="al4" class="form-control form-control-sm">
                                <option>4 days</option>
                            </select>
                        </div>
                    </div>

                    <div class="mt-3">
                        <div class="row">
                            <div class="col-6"></div>
                            <div class="col-3">
                                <small class="font-weight-bold text-muted">Start warning</small>
                            </div>
                            <div class="col-3">
                                <small class="font-weight-bold text-muted">Mark urgent</small>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4">Break Reminder</div>
                            <div class="col-2">
                                <toggle-button
                                    :value="false"
                                    color="#D64571"
                                    :sync="true"
                                    :labels="true"
                                />
                            </div>
                            <div class="col-3">
                                <select class="form-control form-control-sm">
                                    <option>60 days</option>
                                </select>
                            </div>
                            <div class="col-3">
                                <select class="form-control form-control-sm">
                                    <option>7 days</option>
                                </select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4">Staff has day off</div>
                            <div class="col-2">
                                <toggle-button
                                    :value="false"
                                    color="#D64571"
                                    :sync="true"
                                    :labels="true"
                                />
                            </div>
                            <div class="col-3">
                                <select class="form-control form-control-sm">
                                    <option>60 days</option>
                                </select>
                            </div>
                            <div class="col-3">
                                <select class="form-control form-control-sm">
                                    <option>7 days</option>
                                </select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4">Car Insurance expires</div>
                            <div class="col-2">
                                <toggle-button
                                    :value="false"
                                    color="#D64571"
                                    :sync="true"
                                    :labels="true"
                                />
                            </div>
                            <div class="col-3">
                                <select class="form-control form-control-sm">
                                    <option>60 days</option>
                                </select>
                            </div>
                            <div class="col-3">
                                <select class="form-control form-control-sm">
                                    <option>7 days</option>
                                </select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4">Driver's license expires</div>
                            <div class="col-2">
                                <toggle-button
                                    :value="false"
                                    color="#D64571"
                                    :sync="true"
                                    :labels="true"
                                />
                            </div>
                            <div class="col-3">
                                <select class="form-control form-control-sm">
                                    <option>60 days</option>
                                </select>
                            </div>
                            <div class="col-3">
                                <select class="form-control form-control-sm">
                                    <option>7 days</option>
                                </select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4">TB expires</div>
                            <div class="col-2">
                                <toggle-button
                                    :value="false"
                                    color="#D64571"
                                    :sync="true"
                                    :labels="true"
                                />
                            </div>
                            <div class="col-3">
                                <select class="form-control form-control-sm">
                                    <option>60 days</option>
                                </select>
                            </div>
                            <div class="col-3">
                                <select class="form-control form-control-sm">
                                    <option>7 days</option>
                                </select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4">FBI/ Dept of Justice expires</div>
                            <div class="col-2">
                                <toggle-button
                                    :value="false"
                                    color="#D64571"
                                    :sync="true"
                                    :labels="true"
                                />
                            </div>
                            <div class="col-3">
                                <select class="form-control form-control-sm">
                                    <option>60 days</option>
                                </select>
                            </div>
                            <div class="col-3">
                                <select class="form-control form-control-sm">
                                    <option>7 days</option>
                                </select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4">Annual Performance review</div>
                            <div class="col-2">
                                <toggle-button
                                    :value="false"
                                    color="#D64571"
                                    :sync="true"
                                    :labels="true"
                                />
                            </div>
                            <div class="col-3">
                                <select class="form-control form-control-sm">
                                    <option>60 days</option>
                                </select>
                            </div>
                            <div class="col-3">
                                <select class="form-control form-control-sm">
                                    <option>7 days</option>
                                </select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4">Sexual Harassment Training expires</div>
                            <div class="col-2">
                                <toggle-button
                                    :value="false"
                                    color="#D64571"
                                    :sync="true"
                                    :labels="true"
                                />
                            </div>
                            <div class="col-3">
                                <select class="form-control form-control-sm">
                                    <option>60 days</option>
                                </select>
                            </div>
                            <div class="col-3">
                                <select class="form-control form-control-sm">
                                    <option>7 days</option>
                                </select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4">Overtime</div>
                            <div class="col-2">
                                <toggle-button
                                    :value="false"
                                    color="#D64571"
                                    :sync="true"
                                    :labels="true"
                                />
                            </div>
                            <div class="col-3">
                                <select class="form-control form-control-sm">
                                    <option> over 2 hours</option>
                                </select>
                            </div>
                        </div>

                        <hr
                            style="width:95%;margin: 0.5rem auto;color:#bfbfbf;background: #bfbfbf; height: 1px;"
                        />

                        <h4 class="mt-3">Therapist Client Alerts</h4>

                        <div class="row">
                            <div class="col-4">Warn assessment is due</div>
                            <div class="col-2">
                                <toggle-button
                                    :value="false"
                                    color="#D64571"
                                    :sync="true"
                                    :labels="true"
                                />
                            </div>
                            <div class="col-3">
                                <select class="form-control form-control-sm">
                                    <option>30 days</option>
                                </select>
                            </div>
                            <div class="col-3">
                                <select class="form-control form-control-sm">
                                    <option>5 days</option>
                                </select>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-4">Warn report is due</div>
                            <div class="col-2">
                                <toggle-button
                                    :value="false"
                                    color="#D64571"
                                    :sync="true"
                                    :labels="true"
                                />
                            </div>
                            <div class="col-3">
                                <select class="form-control form-control-sm">
                                    <option>30 days</option>
                                </select>
                            </div>
                            <div class="col-3">
                                <select class="form-control form-control-sm">
                                    <option>5 days</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-4">Therapist no data collected on goal</div>
                        <div class="col-2">
                            <toggle-button
                                :value="false"
                                color="#D64571"
                                :sync="true"
                                :labels="true"
                            />
                        </div>
                        <div class="col-3">
                            <select class="form-control form-control-sm">
                                <option>30 days</option>
                            </select>
                        </div>
                        <div class="col-3">
                            <select class="form-control form-control-sm">
                                <option>5 days</option>
                            </select>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-4">Therapist progress goal off average</div>
                        <div class="col-2">
                            <toggle-button
                                :value="false"
                                color="#D64571"
                                :sync="true"
                                :labels="true"
                            />
                        </div>
                        <div class="col-3">
                            <select class="form-control form-control-sm">
                                <option>Immediately</option>
                            </select>
                        </div>
                        <div class="col-3">
                            <select class="form-control form-control-sm">
                                <option>20%</option>
                            </select>
                        </div>
                    </div>
                </div>
                <!--CLIENT FUNDING ALERTS-->
                <div class="p-3 border-light bg-white my-2">
                    <h4 class="text-capitalize">Client funding alerts</h4>
                    <div class="mt-3">
                        <div class="row">
                            <div class="col-6"></div>
                            <div class="col-3">
                                <small class="font-weight-bold text-muted">Start warning</small>
                            </div>
                            <div class="col-3">
                                <small class="font-weight-bold text-muted">Mark urgent</small>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4">Funding contract expires</div>
                            <div class="col-2">
                                <toggle-button
                                    :value="false"
                                    color="#D64571"
                                    :sync="true"
                                    :labels="true"
                                />
                            </div>
                            <div class="col-3">
                                <select class="form-control form-control-sm">
                                    <option>60 days</option>
                                </select>
                            </div>
                            <div class="col-3">
                                <select class="form-control form-control-sm">
                                    <option>15 days</option>
                                </select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4">Funding usage % low</div>
                            <div class="col-2">
                                <toggle-button
                                    :value="false"
                                    color="#D64571"
                                    :sync="true"
                                    :labels="true"
                                />
                            </div>
                            <div class="col-3">
                                <select class="form-control form-control-sm">
                                    <option>&gt; 10% margin</option>
                                </select>
                            </div>
                            <div class="col-3">
                                <select class="form-control form-control-sm">
                                    <option>monthly</option>
                                </select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4">Insurance card expires</div>
                            <div class="col-2">
                                <toggle-button
                                    :value="false"
                                    color="#D64571"
                                    :sync="true"
                                    :labels="true"
                                />
                            </div>
                            <div class="col-3">
                                <select class="form-control form-control-sm">
                                    <option>60 days</option>
                                </select>
                            </div>
                            <div class="col-3">
                                <select class="form-control form-control-sm">
                                    <option>15 days</option>
                                </select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-8">Keep client on schedule if contract expires</div>
                            <div class="col-2">
                                <toggle-button
                                    :value="false"
                                    color="#D64571"
                                    :sync="true"
                                    :labels="true"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <!--APP OVERAGE FEES-->
                <div class="p-3 border-light bg-white my-2">
                    <h4 class="text-capitalize">Application overage fees - use alerts</h4>
                    <div class="mt-3">
                        <div class="row">
                            <div class="col-4">
                                File storage for attachments 1 GB per month data limit
                            </div>
                            <div class="col-2">
                                <toggle-button
                                    :value="false"
                                    color="#D64571"
                                    :sync="true"
                                    :labels="true"
                                />
                            </div>
                            <div class="col-3">
                                <select class="form-control form-control-sm">
                                    <option>80%</option>
                                </select>
                            </div>
                            <div class="col-3">
                                <select class="form-control form-control-sm">
                                    <option>100%</option>
                                </select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4">
                                Check Insurance Eligibility 2500 Clicks per Month
                            </div>
                            <div class="col-2">
                                <toggle-button
                                    :value="false"
                                    color="#D64571"
                                    :sync="true"
                                    :labels="true"
                                />
                            </div>
                            <div class="col-3">
                                <select class="form-control form-control-sm">
                                    <option>80%</option>
                                </select>
                            </div>
                            <div class="col-3">
                                <select class="form-control form-control-sm">
                                    <option>100%</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <!--BILLING ALERTS-->
                <div class="p-3 border-light bg-white my-2">
                    <h4 class="text-capitalize">Billing alerts</h4>
                    <div class="mt-3">
                        <div class="row">
                            <div class="col-6"></div>
                            <div class="col-3">
                                <small class="font-weight-bold text-muted">Start warning</small>
                            </div>
                            <div class="col-3">
                                <small class="font-weight-bold text-muted">Mark urgent</small>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4">Submit claims countdown expires</div>
                            <div class="col-2">
                                <toggle-button
                                    :value="false"
                                    color="#D64571"
                                    :sync="true"
                                    :labels="true"
                                />
                            </div>
                            <div class="col-3">
                                <select class="form-control form-control-sm">
                                    <option>60 days</option>
                                </select>
                            </div>
                            <div class="col-3">
                                <select class="form-control form-control-sm">
                                    <option>15 days</option>
                                </select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4">Appeal claims countdown starts</div>
                            <div class="col-2">
                                <toggle-button
                                    :value="false"
                                    color="#D64571"
                                    :sync="true"
                                    :labels="true"
                                />
                            </div>
                            <div class="col-3">
                                <select class="form-control form-control-sm">
                                    <option>&gt; 10% margin</option>
                                </select>
                            </div>
                            <div class="col-3">
                                <select class="form-control form-control-sm">
                                    <option>monthly</option>
                                </select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4">Claim rejected</div>
                            <div class="col-2">
                                <toggle-button
                                    :value="false"
                                    color="#D64571"
                                    :sync="true"
                                    :labels="true"
                                />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4">Claim overpaid</div>
                            <div class="col-2">
                                <toggle-button
                                    :value="false"
                                    color="#D64571"
                                    :sync="true"
                                    :labels="true"
                                />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4">Claim underpaid</div>
                            <div class="col-2">
                                <toggle-button
                                    :value="false"
                                    color="#D64571"
                                    :sync="true"
                                    :labels="true"
                                />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4">Prepayment Underpaid/Overpaid</div>
                            <div class="col-2">
                                <toggle-button
                                    :value="false"
                                    color="#D64571"
                                    :sync="true"
                                    :labels="true"
                                />
                            </div>
                            <div class="col-3">
                                <select class="form-control form-control-sm">
                                    <option>15 days</option>
                                </select>
                            </div>
                            <div class="col-3">
                                <select class="form-control form-control-sm">
                                    <option>1 day</option>
                                </select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-4">Charge insurance flow</div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div
                                    v-for="(o, i) in [
                                        'Manually send',
                                        'Immediately',
                                        'End of every day',
                                        'Last day of week',
                                    ]"
                                    class="form-check form-check-inline"
                                >
                                    <input class="form-control-sm mr-2" type="radio" />
                                    <label>{{ o }}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-4 p-2">
                <div class="p-3 border-light bg-white my-2">
                    <h4>Email & Text Updates</h4>
                    <div>I would like to receive updates:</div>
                    <div class="form-check form-check-inline w-100">
                        <input
                            class="form-control form-control-sm mr-1"
                            style="max-width:2rem;"
                            type="checkbox"
                            id="email"
                            :value="'email'"
                        />
                        <label class="mb-0" for="email" style="line-height: 0.8;"
                            ><small class="">E-mail me</small></label
                        >
                        <input
                            class="form-control form-control-sm mr-1"
                            style="max-width:2rem;"
                            type="checkbox"
                            id="text"
                            :value="'text'"
                        />
                        <label class="mb-0" for="email" style="line-height: 0.8;"
                            ><small class="">Text me</small></label
                        >
                    </div>
                    <div>
                        <p class="mb-0">Messages sent to me</p>
                        <div class="d-flex w-100 justify-content-between">
                            <toggle-button
                                :value="false"
                                color="#D64571"
                                :sync="true"
                                :labels="true"
                            />
                            <select
                                id="msg"
                                class="form-control form-control-sm ml-3 mr-auto"
                                style="max-width:6rem;"
                            >
                                <option>Weekly</option>
                            </select>
                        </div>
                    </div>

                    <div>
                        <p class="mb-0">When an alert is issued for Staff</p>
                        <div class="d-flex w-100 justify-content-between">
                            <toggle-button
                                :value="false"
                                color="#D64571"
                                :sync="true"
                                :labels="true"
                            />
                            <select
                                id="alertstaff"
                                class="form-control form-control-sm ml-3 mr-auto"
                                style="max-width:6rem;"
                            >
                                <option>Daily</option>
                            </select>
                        </div>
                    </div>

                    <div>
                        <p class="mb-0">When an alert is issued for Client</p>
                        <div class="d-flex w-100 justify-content-between">
                            <toggle-button
                                :value="false"
                                color="#D64571"
                                :sync="true"
                                :labels="true"
                            />
                            <select
                                id="alertclient"
                                class="form-control form-control-sm ml-3 mr-auto"
                                style="max-width:6rem;"
                            >
                                <option>Immediately</option>
                            </select>
                        </div>
                    </div>
                    <div>
                        <p class="mb-0">Every time I have an appointment on my calendar</p>
                        <div class="d-flex w-100 justify-content-between">
                            <toggle-button
                                :value="false"
                                color="#D64571"
                                :sync="true"
                                :labels="true"
                            />
                            <select
                                id="newcalendarevent"
                                class="form-control form-control-sm ml-3 mr-auto"
                                style="max-width:6rem;"
                            >
                                <option>Immediately</option>
                            </select>
                        </div>
                    </div>
                    <div>
                        <p class="mb-0">Only when I have changes to my calendar</p>
                        <div class="d-flex w-100 justify-content-between">
                            <toggle-button
                                :value="false"
                                color="#D64571"
                                :sync="true"
                                :labels="true"
                            />
                            <select
                                id="changecalendarevent"
                                class="form-control form-control-sm ml-3 mr-auto"
                                style="max-width:6rem;"
                            >
                                <option>Immediately</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="p-3 border-light bg-white my-2">
                    <h4>Email & Text Updates</h4>
                    <div>
                        <p class="mb-0">
                            Please move children that haven'' been active to my archived child
                            account if they haven't been acessed for:
                        </p>
                        <div class="d-flex w-100 justify-content-between">
                            <toggle-button
                                :value="false"
                                color="#D64571"
                                :sync="true"
                                :labels="true"
                            />
                            <select
                                id="archivechild"
                                class="form-control form-control-sm ml-3 mr-auto"
                                style="max-width:6rem;"
                            >
                                <option>Weekly</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "MyAlerts",
};
</script>

<style scoped></style>
